/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Opening_LabelInputs */



/**
* | output |
* | --- |
* | "Opening..." |
*
* @param {Explorer_Info_Opening_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_opening_label = /** @type {((inputs?: Explorer_Info_Opening_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Opening_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouverture...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Öffnung...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Apertura...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Открытие...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Apertura...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开场……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オープニング...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उद्घाटन...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Abertura...")
	return /** @type {LocalizedString} */ ("Opening...")
});